import React from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { useUserState } from 'contexts/auth-context';

const StartPage = () => {
  const { auth } = useUserState();
  return auth.isAuthenticated ? (
    <Redirect to="/groups" />
  ) : (
    <Redirect to="/login" />
  );
};

export default withRouter(StartPage);
